import { map, catchError, switchMap, filter, mapTo, mergeMap, takeUntil, pluck } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import trackActions from '../../../actions/tracks'
import { TrackType } from '../../../actions/tracks/trackTypes'
import { of, timer } from 'rxjs'
import createTrack$ from './createTrack'
import { createLocalAudioTrack, createLocalAudioTrackError } from '../../../actions/tracks/trackActions'

/**
 * Trigger createLocalAudioTrack if the number of max attempts hasn't been reached after an error is dispatched
 * @param actions$ - The Redux actions stream
 * @param state$ - The Redux stream
 */
export const createLocalAudioTrackError$ = (actions$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(TrackType.CREATE_LOCAL_AUDIO_TRACK_ERROR),
  filter(() => state$.value.tracks.numAudioFetchAttempts < state$.value.tracks.maxRetries),
  map(() => createLocalAudioTrack())
)

/** Triggers a call to createLocalAudioTrackError after n seconds
 * unless CREATE_LOCAL_AUDIO_TRACK_SUCCESS is dispatched
 * */
export const createLocalAudioTrackTimeout$ = (action$: ActionsObservable<ReduxAction>) => action$.pipe(
  ofType(TrackType.CREATE_LOCAL_AUDIO_TRACK),
  mergeMap(() =>
    timer(10000).pipe(
      map(() => createLocalAudioTrackError(new Error('Timeout'))),
      takeUntil(
        action$.pipe(
          ofType(TrackType.CREATE_LOCAL_AUDIO_TRACK_SUCCESS, TrackType.CREATE_LOCAL_AUDIO_TRACK_ERROR)
        )
      )
    )
  )
)

export default (actions$: ActionsObservable<ReduxAction>, state$: StateObservable<State>, { createTrack = createTrack$ }) => actions$.pipe(
  ofType(TrackType.CREATE_LOCAL_AUDIO_TRACK),
  filter(() => state$.value.tracks.numAudioFetchAttempts <= state$.value.tracks.maxRetries),
  pluck<ReduxAction, string | undefined>('payload'),
  switchMap(deviceId =>
    createTrack(state$.value.room.room, deviceId || state$.value.tracks.selectedAudioDeviceID, state$.value.user.BTID)
      .pipe(
        map(() => trackActions.createLocalAudioTrackSuccess()),
        takeUntil(actions$.pipe(
          ofType(TrackType.CREATE_LOCAL_AUDIO_TRACK_ERROR)
        )),
        catchError(e => of(trackActions.createLocalAudioTrackError(e)))
      )
  )
)
